
export const colunasStatusEmbarque = [
    {
        nomeColuna: "Status",
        field: "status",
    },
    {
        nomeColuna: "Data",
        field: "data",
    },
    {
        nomeColuna: "Usuário",
        field: "usuario",
    },
];

export const colunasPedidoEmbarque = [
    {
        nomeColuna: "Pedido",
        field: "pedido",
    },
    {
        nomeColuna: "Data",
        field: "data",
    },
    {
        nomeColuna: "Usuário",
        field: "usuario",
    },
];

export const colunasFreteFiscalEmbarque = [
    {
        nomeColuna: "Frete Fiscal",
        field: "freteFiscal",
    },
    {
        nomeColuna: "Data",
        field: "data",
    },
    {
        nomeColuna: "Usuário",
        field: "usuario",
    },
];

export const chavesFormatar = [
    "dataHoraChegadaEmbarque", 
    "dataHoraEmbarcado", 
    "dataHoraChegadaEntrega", 
    "dataHoraEntregue", 
    "previsaoEmbarque", 
    "previsaoEntrega"
];

export const chavesRemover = [
    "deletado",
    "embarqueHistoricoId",
    "contexto",
    "data",
    "usuario",
];
